import React, { useEffect, useState } from 'react';
import * as Yup from "yup";
import Breadcrumbs from '../../components/BreadCrumbs';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import FilePickerField from '../../components/inputFields/FilePickerField';
import { patchMobilePopups, postMobilePopups } from '../../services/mobile_popup';

function MobilePopupForm() {
    const location = useLocation();
    const navigate = useNavigate();
    const [rowData, setRowData] = useState(null);
    const [file, setFile] = useState(null);


    const handleDiscardChanges = (resetForm) => {
        resetForm();
        navigate(-1);
    };

    const handleimageSelect = (file) => {
        setFile(file);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const formData = new FormData();
        if (file && typeof file !== "object") {
            toast.error("Choose an image");
            return;
        }

        if (file && typeof file === "object") {
            formData.append("image", file);
        }

        try {
            const response = rowData ? await patchMobilePopups({ data: formData, id: rowData.id }) : await postMobilePopups(formData);

            if (response?.status === 200 || response.status === 201) {
                toast.success(rowData ? "Popup updated successfully" : "Popup added successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    useEffect(() => {
        if (location.state) {
            setRowData(location.state);
        }
    }, [location]);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Banners', link: '/marketing/mobile-pops' },
            { name: rowData ? 'Update Popup' : 'Add Popup' },
        ]} />
        <div className="mt-8">
            <Formik
                initialValues={rowData || {
                    is_active: true,
                }}
                validationSchema={Yup.object({})}
                enableReinitialize
                onSubmit={handleFormSubmit}
            >
                {({ isSubmitting, resetForm, values, setValues }) => (
                    <Form>
                        <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col md:flex-row gap-4">
                            <div className="flex flex-col w-full">
                                <div className="grid gap-2 grid-cols-1 md:grid-cols-2 mb-3 items-end">
                                    <FilePickerField
                                        preloadedFile={file}
                                        label='Image'
                                        placeHolder={'Select File (9:16)'}
                                        onFileSelect={handleimageSelect}
                                    />
                                </div>
                                <div className="py-5 flex justify-end gap-6">
                                    <div>
                                        <Button
                                            type="button"
                                            className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                            onClick={() => handleDiscardChanges(resetForm)}
                                            disabled={isSubmitting}
                                        >
                                            Discard Changes
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Saving..." : "Save"}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    </>);
}

export default MobilePopupForm;